export default "__VITE_ASSET__fZcsBtKRLAnew$MzpXDvvw__"